import React, { useContext } from 'react'

import { DataContext } from './DataContext'
import NoDataComponent from '../../../elem/table/client/NoDataComponent'
import TableContent from '../../../elem/table/client/TableContent'
import parseColumns from '../../../../utils/table/parseColumns'

export default () => {
    const { detailData, filterData, visibleTab, isLoading } = useContext(
        DataContext
    )
    if (
        detailData &&
        detailData.samples &&
        filterData &&
        filterData.samples &&
        visibleTab === 'samples'
    ) {
        const formFields = filterData.samples
        const sampleDetailsData = detailData.samples
        const columns = parseColumns(sampleDetailsData, formFields)
        return (
            <div className="is-size-7 sampleDetailWrapper">
                <NoDataComponent
                    data={sampleDetailsData}
                    isLoading={isLoading}
                />
                <TableContent
                    name="sampleDetails"
                    columns={columns}
                    data={sampleDetailsData}
                    containerClass={'detailTableWrapper'}
                    loading={isLoading}
                    isClickable={false}
                />
            </div>
        )
    } else {
        return null
    }
}
